export function requiredStringField(field: string, validationMessage: string, hasOldError: boolean): {
    hasError: boolean,
    errorMessage: string
} 
{
    if (!field || field === "") {
        return {
            hasError: true,
            errorMessage: validationMessage
        };
    }

    return {
        hasError: hasOldError,
        errorMessage: ""
    };
}


const emailRegex = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

export function emailField(field: string, validationMessage: string, hasOldError: boolean): {
    hasError: boolean,
    errorMessage: string
} 
{
    if (!emailRegex.test(field)) {
        return {
            hasError: true,
            errorMessage: validationMessage
        };
    }

    return {
        hasError: hasOldError,
        errorMessage: ""
    };
}